import Emitter from "./Emitter";

export default class OpenHelp extends Emitter {
    constructor(gb) {
        super(gb);
    }

    _default() {
        return
    }
}
